import React from "react";
import { Box, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";

export default function RatingStars({ value = 4.2 }) {
  const full = Math.floor(value);
  const half = value - full >= 0.5;
  const stars = [];
  
  for (let i = 0; i < 5; i++) {
    if (i < full) {
      stars.push(<StarIcon key={i} sx={{ fontSize: 16, color: "#F59E0B" }} />);
    } else if (i === full && half) {
      stars.push(<StarIcon key={i} sx={{ fontSize: 16, color: "#F59E0B", opacity: 0.6 }} />);
    } else {
      stars.push(<StarIcon key={i} sx={{ fontSize: 16, color: "#E5E7EB" }} />);
    }
  }
  
  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      {stars}
      <Typography variant="caption" color="text.secondary">
        {value.toFixed(1)}
      </Typography>
    </Box>
  );
}